/** 
 * @type {InvestorReportsFilter} 
 */
const filter = {
    with: null,
    orderBy: null,
    ids: [],
    investor_ids: [],
    plan_report_ids: [],
    contract_ids: [],
    years: [],
    appends: [],
}
/** 
* @returns {InvestorReportsFilter} 
*/
export default function () {
    return JSON.parse(JSON.stringify(filter));
} 



// WEBPACK FOOTER //
// ./resources/js/filters/InvestorReportsFilter.js